var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrfIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.2,
    height: 34.2,
    viewBox: "0 0 34.2 34.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4026",
    "data-name": "Group 4026",
    transform: "translate(-1733 -155.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M23.5,39.8A17.1,17.1,0,1,1,40.6,22.7,17.123,17.123,0,0,1,23.5,39.8Zm0-32.72A15.62,15.62,0,1,0,39.12,22.7,15.643,15.643,0,0,0,23.5,7.08Z",
    transform: "translate(1726.6 149.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(1744.881 165.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M39.12,45.738H38.108A1.214,1.214,0,0,1,36.9,44.531V33.508A1.214,1.214,0,0,1,38.108,32.3H39.12a1.214,1.214,0,0,1,1.208,1.208V44.531A1.214,1.214,0,0,1,39.12,45.738Z",
    transform: "translate(-36.9 -32.3)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(1751.891 165.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M57.12,45.738H56.108A1.214,1.214,0,0,1,54.9,44.531V33.508A1.214,1.214,0,0,1,56.108,32.3H57.12a1.214,1.214,0,0,1,1.208,1.208V44.531A1.214,1.214,0,0,1,57.12,45.738Z",
    transform: "translate(-54.9 -32.3)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrfIcon3);
export default __webpack_public_path__ + "static/media/CRFIcon3.b33250e2.svg";
export { ForwardRef as ReactComponent };